import React, {useState} from 'react';
import {SingleDatePicker} from 'react-dates';
import {momentObj} from 'react-moment-proptypes';
import PropTypes from 'prop-types';

const DatePickerWrapper = ({ dateValue, onDateChange, id, disabled, block, ...others }) => {
	const [hasFocus, setFocus] = useState(false);
	return (
		<SingleDatePicker
			disabled={disabled}
			isOutsideRange={() => false}
			date={dateValue}
			onDateChange={onDateChange}
			focused={hasFocus}
			onFocusChange={({ focused }) => setFocus(focused)}
			displayFormat="DD-MM-YYYY"
			id={id}
			block={block}
			{...others}
    />
	);
};

DatePickerWrapper.defaultProps = {
	disabled: false,
	onDateChange: () => {}
};

DatePickerWrapper.propTypes = {
	dateValue: momentObj.isRequired,
	onDateChange: PropTypes.func,
	id: PropTypes.string.isRequired,
	disabled: PropTypes.bool
};

export default DatePickerWrapper;
